export default "__VITE_ASSET__BszWu9AN__"